// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2HXq5","imageUploader":"EGiftCard_imageUploader__2PMoR"};